import type { Mixpanel } from "mixpanel-browser";

export function trackMixPanel<Untyped extends true | false = false>(
  mixpanel: Mixpanel | undefined | null,
  event: Untyped extends true ? UntypedEvent : Event,
  _options?: { untyped: Untyped },
) {
  mixpanel?.track(event.name, event.property);
}

export function registerMixPanelParameters(
  mixpanel: Mixpanel | undefined | null,
  parameters: Record<string, unknown>,
) {
  mixpanel?.register(parameters);
}

type UntypedEvent = {
  name: string;
  property: Record<string, unknown>;
};

type Event = BookmarkArticleEvent | SubscriptionMeteringEvent | SubscriptionEntryPointEvent;

type BookmarkArticleEvent = {
  name: "Bookmark Article";
  property: {
    Action: "Remove" | "Add";
    Location: BookmarkArticleLocation;
  };
};
export type BookmarkArticleLocation =
  | "Topic Index"
  | "Author Page"
  | "Article"
  | `${"Article"} ${"Side" | "Adhesive"}`
  | "Homepage"
  | "Section"
  | "Other Index";

type SubscriptionMeteringEvent = {
  name: "Subscription Metering";
  property: {
    "Metering Article Count": string;
    "User Action": "Click Subscribe" | "Click Close" | "Close" | "Sign in";
  };
};

type SubscriptionEntryPointEvent = {
  name: "Subscription Entry Point/Article Footer";
  property: {
    "User Action": `${"Close" | "Support Us"}`;
  };
};
